var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7323 3.87012C12.9625 2.53678 11.038 2.53678 10.2682 3.87012L2.04095 18.1201C1.27115 19.4535 2.2334 21.1201 3.773 21.1201H20.2275C21.7671 21.1201 22.7293 19.4535 21.9595 18.1201L13.7323 3.87012ZM12.2503 8.87011C12.6645 8.87011 13.0003 9.15793 13.0003 9.51297V14.2273C13.0003 14.5823 12.6645 14.8701 12.2503 14.8701C11.836 14.8701 11.5003 14.5823 11.5003 14.2273V9.51297C11.5003 9.15793 11.836 8.87011 12.2503 8.87011ZM13.0003 16.4326C13.0003 16.1219 12.6645 15.8701 12.2503 15.8701C11.836 15.8701 11.5003 16.1219 11.5003 16.4326V16.8076C11.5003 17.1183 11.836 17.3701 12.2503 17.3701C12.6645 17.3701 13.0003 17.1183 13.0003 16.8076V16.4326Z",
    fill: "#E50B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.fe02fac1cb3d36f0e9e109bb5e81d405.svg";
export { ForwardRef as ReactComponent };